import "./footer.css"
import logoBranca from "../../../assets/general_assets/logoBranca.png"
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { use, useEffect } from "react";

export default function Footer() {

    let location = useLocation();
    let Tel = "";
    let instagram = "";
    let whatsapp = "";

    if (location.pathname.includes("SP")) {
        Tel = "(11)98973-2215";
        instagram = "https://www.instagram.com/teamcreziosp/"
        whatsapp = "https://wa.me/5511989732215?text=Ol%C3%A1%2C+gostaria+de+marcar+uma+aula+na+Team+Crezio%21"

    // if(location.pathname.includes("RJ") || location.pathname.includes("SkyFit") || location.pathname.includes("Locatelli") || location.pathname === "/")
    } else  {
        Tel = "(24) 99934-3720";
        instagram = "https://www.instagram.com/creziochaveslutas?igsh=NnF0dWEyNWs0NWRx";
        whatsapp = "https://api.whatsapp.com/send?phone=5524999343720&text=Ol%C3%A1%20gostaria%20de%20marcar%20uma%20aula%20na%20Team%20Crezio!";

    }

    const scrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})   
    }

    return (
        <>

            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>
            <footer id="footer" className="footer">

                <img onClick={scrollTop} className="footer_logo" alt="TeamCrezioLogo" src={logoBranca}></img>

                <div className="footer_info">
                    <div>
                        <h1>Entre em Contato em caso de dúvidas</h1>
                        <p>{Tel}</p>
                        <a href="mailto:contato@teamcrezio.com.br?subject=Duvida%20Do%20Cliente">contato@teamcrezio.com.br</a>
                        
                    </div>

                    <div>
                        <h1>Onde nos procurar?</h1>
                        <div className="icons">

                            <Link id="instagram" to={instagram}><i class="bi bi-instagram"></i></Link>
                            <Link id="whatsapp" to={whatsapp}><i class="bi bi-whatsapp"></i></Link>



                        </div>
                    </div>
                    <div>
                        <span className="copyright"><i class="bi bi-c-circle"></i>All Rights Reserved</span>
                    </div>
                </div>


            </footer>

        </>
    )
}